module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "title": 'Connect to LMS integration',
      "size": 'md',
      "disableOutsideClick": true
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('body', {
    staticClass: "px-7 pb-10 flex flex-col flex-grow justify-center items-center overflow-y-auto"
  }, [_c('img', {
    staticClass: "w-14",
    attrs: {
      "src": "/static/waffle_icons/unlock.svg"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "my-8 text-2xl font-bold"
  }, [_vm._v("\n      You’ve discovered a premium feature!\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "mb-8 flex flex-col text-base font-normal"
  }, [_c('div', {
    staticClass: "flex justify-center"
  }, [_vm._v("\n        You must have a schoolwide license to roster your class,\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_vm._v("\n        create assignments and share assessment data with this integration.\n      ")])]), _vm._v(" "), _c('div', {
    staticClass: "flex flex-col"
  }, [_c('button', {
    staticClass: "mb-2.5 px-8 py-2 bg-primary rounded cursor-pointer text-white font-semibold",
    on: {
      "click": _vm.upgrade
    }
  }, [_vm._v("\n        Upgrade Now\n      ")]), _vm._v(" "), _c('button', {
    staticClass: "px-8 py-2 bg-white hover:bg-gray-100 rounded cursor-pointer text-gray-500 font-semibold",
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v("\n        Maybe Later\n      ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-8d60f65a!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/modals/integrationsPremiumFeatureModal.vue
// module id = 1009
// module chunks = 61